import React from "react";
import iconVerifiedGold from "../../assets/icon-verified-gold.svg";
import iconGreenDistrict from "../../assets/icon-green-district.svg";
import iconBriefcase from "../../assets/icon-briefcase.svg";
import iconStars from "../../assets/icon-stars.svg";

const LAYERS = [
    { icon: iconVerifiedGold, title: "Clear Audit Trail", desc: "Every update is logged, timestamped and attributed, so there's always a single source of truth to check." },
    { icon: iconBriefcase, title: "Centralized Project Control", desc: "Unify teams, documents, photos and data in a single source of truth." },
    { icon: iconVerifiedGold, title: "Authenticity Verified", desc: "Compliant with the global Content Authenticity standard — every record is tamper-evident." },
    { icon: iconGreenDistrict, title: "Digital Portfolio", desc: "A permanent, living record of every project, visible to the global market." },
    { icon: iconBriefcase, title: "Stakeholder Trust", desc: "Role-based access and transparency across the entire ecosystem." },
    { icon: iconVerifiedGold, title: "Immutable Audit Trail", desc: "Full version control on every record, from first capture to final sign-off." },
    { icon: iconStars, title: "AI-Enabled Discovery", desc: "Smart search connects verified work with the right buyers and investors." },
];

const PubTrustLayers = () => (
    <section className="pub-trust-layers" id="features">
        <p className="pub-section-overtitle">Why Global Teams Choose Conra</p>
        <h2 className="h1-48-600">The trust layer for every project</h2>
        <p className="pub-trust-sub">One verification engine, built into everything on Conra.</p>
        <div className="pub-trust-grid">
            <div className="pub-trust-track">
                {[...LAYERS, ...LAYERS].map((l, i) => (
                    <div key={i} className="pub-trust-card" aria-hidden={i >= LAYERS.length}>
                        <img src={l.icon} alt={l.title} className="pub-trust-icon" />
                        <h4 className="pub-trust-title">{l.title}</h4>
                        <p className="pub-trust-desc">{l.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default PubTrustLayers;
